import App from './App.svelte';

new App({
	target: document.getElementById("sv_shop_brand"),
});